import { Cell, PieChart, Pie } from 'recharts';
import { theme } from 'twin.macro';

import { BrandSafetyChartData } from './BrandSafetyBarChart';

type BrandSafetyBarChartProps = {
  data: BrandSafetyChartData[];
  width?: number;
  height?: number;
};

export const BrandSafetyPieChart = ({
  data,
  width = 80,
  height = 80,
}: BrandSafetyBarChartProps) => (
  <PieChart width={width} height={height}>
    <Pie
      data={data}
      cx='50%'
      cy='50%'
      innerRadius='45%'
      outerRadius='100%'
      paddingAngle={0}
      dataKey='value'
      minAngle={3}
      stroke={theme`colors.accent-2`}
      strokeWidth={1}>
      {data.map((entry, index) => (
        <Cell key={`cell-${index}`} fill={entry.fill} style={{ outline: 'none' }} />
      ))}
    </Pie>
  </PieChart>
);
